import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { CommonSelectionInterface } from "../../share/interface/common.interface";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class O2OIndustrySectorService {
  private basePath: string = `${environment.url}/api/O2OIndustrySector`;
  constructor(private http: HttpClient) {}

  getIndustrySectors(): Observable<CommonSelectionInterface[]> {
    return this.http.get<CommonSelectionInterface[]>(
      `${this.basePath}/GetIndustrySectors`
    );
  }

  getSubIndustrySectors(industrySectorId: string): Observable<CommonSelectionInterface[]> {
    return this.http.get<CommonSelectionInterface[]>(
      `${this.basePath}/GetSubIndustrySectors/${industrySectorId}`
    );
  }
}
